import { render, staticRenderFns } from "./cmpgraficobarralateral.vue?vue&type=template&id=488730a5&"
import script from "./cmpgraficobarralateral.vue?vue&type=script&lang=js&"
export * from "./cmpgraficobarralateral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports